import { useEffect } from 'react';

const TOOLTIP_SELECTOR = '.cont-glossary-tooltip';
const EDGE_LEFT     = 'cont-tooltip-edge-left';
const EDGE_RIGHT    = 'cont-tooltip-edge-right';

/**
 * useTooltip
 * Attaches a single delegated listener to the specified container (or document.body)
 * to dynamically adjust tooltip edge classes based on available space.
 *
 * @param {string} containerSelector - CSS selector for the container element.
 */
const useTooltip = (containerSelector = '.ch-lesson-width') => {
    useEffect(() => {
        const container = document.querySelector(containerSelector) || document.body;

        const rootStyles = getComputedStyle(document.documentElement);
        const MARGIN = parseFloat(rootStyles.getPropertyValue('--spacing-unit')) || 8;

        const handlePointerEnter = event => {
            const el = event.target;
            if (!container || !el.matches(TOOLTIP_SELECTOR)) return;

            // Compute container and element bounds
            const cRect = container.getBoundingClientRect();
            const eRect = el.getBoundingClientRect();

            // Compute tooltip width from ::after pseudo-element
            const afterStyle = window.getComputedStyle(el, '::after');
            const tipWidth = parseFloat(afterStyle.width) || 0;

            // Center X of the trigger element
            const centerX = eRect.left + eRect.width / 2;

            // Reset any existing edge classes
            el.classList.remove(EDGE_LEFT, EDGE_RIGHT);

            // Decide which edge to clamp to
            if (centerX - tipWidth / 2 < cRect.left + MARGIN) {
                el.classList.add(EDGE_LEFT);
            } else if (centerX + tipWidth / 2 > cRect.right - MARGIN) {
                el.classList.add(EDGE_RIGHT);
            }
        };

        container.addEventListener('pointerenter', handlePointerEnter, true);

        return () => container.removeEventListener('pointerenter', handlePointerEnter, true);
    }, [containerSelector]);
};

export default useTooltip;
